import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultDescription:
    'Book accommodations for yourself or your workforce using one of the largest databases of hotels and remote lodges in North America.',
  defaultTitle: 'Transforming the Way Companies Manage Travel - LodgeLink'
});

export default messages;
